import type { BotDifficulty, BotMemory, BotPersonality } from "./bot-types.js";
import type { ConflictIntent, SeatObservation } from "./types.js";

export interface BotPlanningContext {
  readonly rootSeed: string;
  readonly personality: BotPersonality;
  readonly difficulty: BotDifficulty;
  readonly projected?: SeatObservation;
}

export interface BotDecision {
  readonly intent: ConflictIntent | { readonly kind: "wait" };
  readonly memory: BotMemory;
  readonly reason: string;
  readonly projectionHorizonMs: number;
}

export interface Selected {
  readonly intent: ConflictIntent;
  readonly reason: string;
  readonly targetId?: string;
}

export function selected(intent: ConflictIntent, reason: string, targetId?: string): Selected {
  return { intent, reason, ...(targetId ? { targetId } : {}) };
}
